import type { FC } from 'react';

import type { LinePattern } from '@ipfabric/utils';
import { type SingleValueProps, components } from 'react-select';

interface OptionType {
  value: LinePattern;
  label: string;
}

export const StrokeValue: FC<SingleValueProps<OptionType>> = (props) => (
  <components.SingleValue {...props}>
    <div className='flex flex-row items-center'>
      <span
        className='graph-layout-settings-protocol-options__stroke mr-lgu-3'
        style={{ borderBottomStyle: props.data.value }}
      />
      <span className='mr-lgu-1'>{props.data.label}</span>
    </div>
  </components.SingleValue>
);
